import styled from 'styled-components';
import { Row } from '@zillow/zrs-comet';
import { LabeledControl } from '@zillow/constellation';

export const StyledLabelControl = styled(LabeledControl)`
    flex-shrink: 0;
`;

export const StyledRow = styled(Row)`
    flex-shrink: 0;
`;
